module.exports = __webpack_public_path__ + "static/img/testimony4.ad2404f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/testimony4.png
// module id = MOrx
// module chunks = 1 3